import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfileManageComponent } from '../profile-manage/profile-manage.component';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';
import { InsuranceInformationComponent } from '../insurance-information/insurance-information.component';
import { FormConfigService } from '../forms-config.service';
import { AppStateService } from '../../app-state.service';

@Component({
  selector: 'app-profile-tabs',
  templateUrl: './profile-tabs.component.html',
  styleUrls: ['./profile-tabs.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    ProfileManageComponent,
    DocumentUploadComponent,
    InsuranceInformationComponent
  ],
  providers: [FormConfigService]
})
export class ProfileTabsComponent implements OnInit {
  selectedFiles: { file: File, docCategory: number, description: string }[] = [];
  formData: any = {};

  constructor(
    private formConfigService: FormConfigService,
    private appStateService: AppStateService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.formData.clientID = this.appStateService.getState().clientId || '';
    this.formData.patientID = this.appStateService.getState().patientId || '';
  }

  onTabChange(event: any) {
  }

  onUploadComplete(event: { success: boolean, count: number }) {
    if (event.success) {
      // Show snackbar with option to view documents
      const snackBarRef = this.snackBar.open(
        `${event.count} document(s) uploaded successfully!`,
        'View Documents',
        { duration: 5000 }
      );

      snackBarRef.onAction().subscribe(() => {
        this.router.navigate(['/dashboard', 'documents']);
      });
    }
  }
}
